import React from "react";

const variantClasses = {
  ghost: "bg-transparent ",
  default: "bg-transparent",
  addmore: "bg-boonsdarkbg text-white",
  black: "bg-black hover:bg-gray-800 text-white",
  gray: "bg-addmorebg text-textgray",
  orange: "bg-boonsOrange text-white",
};

const sizeClasses = {
  back: "px-0 py-0",
  sm: "px-2 py-1 text-sm",
  md: "px-4 py-2 text-base",
  lg: "px-6 py-3 text-lg",
  xxl: "px-8 py-4 text-[40px]",
  add: "lg:text-[60px] md:text-[40px] text-[25px]",
  custom: "h-full lg:text-[44px] md:text-[32px] sm:text-[24px]",
  addmore: "text-[15px] md:text-[35px] sm:text-[20px] lg:text-[45px]",
  home: "text-[15px] md:text-[35px] sm:text-[20px] lg:text-[35px]"
};

const Button = ({ variant = "default", size = "md", className = "", disabled, children, onClick }) => {
  const baseClasses = `rounded font-medium focus:outline-none flex items-center justify-center ${variantClasses[variant]} ${sizeClasses[size]} ${className}`;

  return (
    <button className={baseClasses} onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
};

export default Button;
